var containerStyles = {
  marginTop: '-1px',
  position: 'absolute',
  zIndex: '2',
  backgroundColor: 'white',
  border: '1px solid',
  borderColor: 'primaries.3',
  boxShadow: '0 0 4px 0 #0054A6',
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px',
  ul: {
    fontSize: 'sm',
    listStyleType: 'none',
    paddingInlineStart: '0px',
    marginBlock: '0px',
    '.react-autosuggest__suggestion': {
      borderTop: '1px solid #eaeaea'
    },
    '.react-autosuggest__suggestion--highlighted': {
      backgroundColor: 'primary',
      color: 'white'
    }
  },
  '&::before': {
    content: '""',
    display: 'block',
    height: '6px',
    backgroundColor: 'white',
    position: 'absolute',
    top: '-6px'
  },
  suggestionList: {
    overflow: 'hidden',
    maxHeight: '415px',
    overflowY: 'auto',
    variant: 'scrollbar.text-area'
  }
};
var typeahead = {
  container: containerStyles,
  iconClose: {
    color: 'neutral.dark',
    cursor: 'pointer'
  },
  iconSearch: {
    color: 'neutral.dark'
  }
};

export { typeahead };
//# sourceMappingURL=typeahead.esm.js.map
